<div class="phase-summary-item" [class.editing]="isEditing" (click)="onItemClick()">
  <app-project-config-node
    [itemNumber]="itemNumber"
    [value]="phase.title"
    [placeholder]="'Phase Name'"
    [isEditing]="isEditing"
    [(selected)]="isSelected"
    [allowEdit]="true"
    [allowDelete]="true"
    [color]="'var(--color-phase)'"
    [validationCallback]="validationCallback"
    [displayTemplate]="displayTemplate"
    [editTemplate]="editTemplate"
    (onSave)="handleSave()"
    (onCancel)="onCancel.emit()"
    (onDelete)="onDelete.emit()"
    (onStartEdit)="onEditing()"
    (hovering)="hovering.emit($event)"
  >
    <!-- Display Template -->
    <ng-template #displayTemplate>
      <div class="phase-display">
        <span>{{ itemNumber }}.</span>
        <span class="phase-name">{{ phase.title }}</span>
      </div>
    </ng-template>

    <!-- Edit Template -->
    <ng-template #editTemplate>
      <div class="phase-edit-container">
        <div class="edit-form">
          <div class="name-field">
            <dx-text-box
              [(value)]="editingPhase.title"
              i18n-placeholder="@@name"
              placeholder="Name"
              valueChangeEvent="input"
              class="gpd-input"
              validationMessageMode="always"
              [maxLength]="100"
            >
              <dx-validator>
                <dxi-validation-rule type="required" i18n-message="@@nameRequired" message="Name is required" />
                <dxi-validation-rule
                  type="custom"
                  [reevaluate]="true"
                  [validationCallback]="uniqueNameValidationCallback"
                  i18n-message="@@nameAlreadyExists"
                  message="Name already Exists"
                />
              </dx-validator>
            </dx-text-box>
          </div>
          <div class="checkbox-field">
            <dx-check-box
              [(value)]="editingPhase.showInGantt"
              [text]="messageShowInGantt"
              class="gpd-input"
            ></dx-check-box>
          </div>
        </div>
      </div>
    </ng-template>
  </app-project-config-node>
</div>
